export const PHRASE_TRIGGER_RESULTS_LIMIT = 10;
